module.exports = "img/flags/IE.a22997c.png";